import { useState } from 'react';
import { DropdownItem } from 'reactstrap';
import { MenuItemWrapper } from './MenuItem.styled';

function MenuItem({ label, href, children }:any) {

  const [open, setOpen] = useState(false);
  const hasChildren = children && children.length > 0;

  return (
   <MenuItemWrapper>
    <div className="submenu-container"
      onPointerEnter={(e) => {
        if (e.pointerType === "mouse") setOpen(true);
      }}
      onPointerLeave={(e) => {
        if (e.pointerType === "mouse") setOpen(false);
      }}
    >
      <div className="menu-row">
        <DropdownItem href={href} toggle={false}>{label}</DropdownItem>

        {hasChildren && (
          <span className={`toggle-icon ${open ? "open" : ""}`} 
            onClick={(e) => {
              e.stopPropagation();
              setOpen(!open);
            }}
          >
            ▸
          </span>
        )}
      </div>

      {hasChildren && open && (
        <div className="submenu">
          {children.map((child: any, idx: any) => (
             <div id="menu-wrap">
               <span id="prefix" className="fa fa-angle-right"></span>
               <MenuItem key={idx} {...child} />
               {children.length !== idx+1 && <DropdownItem divider />}
            </div>
          ))}
        </div>
      )}
    </div>
 </MenuItemWrapper>
)
};

export default MenuItem;
